export enum CONNECTIONS_DEFAULT_FIELDS {}
